import API from "../Api";

export const helpTree = (id) => API.get("/api/v1/help/" + id);

export const sendTicket = (ticket) =>
  API.post(`/api/v1/help`, ticket);